function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  className: "above_svg__Thumbnail_ above_svg__Shared above_svg__Gallery above_svg__Album above_svg__Style_Above"
}, /*#__PURE__*/React.createElement("rect", {
  width: 26,
  height: 22,
  x: 23,
  y: 31,
  fill: "#80B1FF",
  className: "above_svg__illus-clr-1",
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D6E6FF",
  d: "M32.552 40.465l1.968 1.975 2.835-3.563a1 1 0 011.49-.085l5.517 5.502c.631.63.186 1.709-.706 1.709H28.344c-.87 0-1.325-1.032-.739-1.675l3.5-3.832a1 1 0 011.447-.03",
  className: "above_svg__illus-clr-3"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3885FF",
  d: "M26 24h20v2H26v-2zm5-3h10v-2H31v2z",
  className: "above_svg__illus-clr-2"
}));

function SvgAbove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    fill: "none",
    viewBox: "0 0 72 72"
  }, props), _ref);
}

export default "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='72' height='72' fill='none' viewBox='0 0 72 72'%3E %3Cg class='Thumbnail_ Shared Gallery Album Style_Above'%3E %3Crect width='26' height='22' x='23' y='31' fill='%2380B1FF' class='illus-clr-1' rx='2'/%3E %3Cpath fill='%23D6E6FF' d='M32.552 40.465l1.968 1.975 2.835-3.563a1 1 0 011.49-.085l5.517 5.502c.631.63.186 1.709-.706 1.709H28.344c-.87 0-1.325-1.032-.739-1.675l3.5-3.832a1 1 0 011.447-.03' class='illus-clr-3'/%3E %3Cpath fill='%233885FF' d='M26 24h20v2H26v-2zm5-3h10v-2H31v2z' class='illus-clr-2'/%3E %3C/g%3E %3C/svg%3E";
export { SvgAbove as ReactComponent };